import { createTheme, type Shadows } from '@mui/material';

const createShadow = (px: number) => {
  return `0 0 ${px}px 0 rgba(53,64,82,.07)`;
};

const shadows: Shadows = [
  'none',
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
  createShadow(14),
];

const theme = createTheme({
  palette: {
    primary: {
      main: '#3e52ff',
    },
    secondary: {
      main: '#ff4081',
    },
  },
  typography: {
    fontFamily: ['Noto Sans JP', 'sans-serif'].join(','),
    fontSize: 14,
    body1: {
      fontSize: 14,
    },
  },
  shadows,
});

export default theme;
